<script>
  import { Link, link } from "svelte-routing";
  import { auth, hasAlpacaAccount } from "../../stores/auth.js";
  import Logo from "../Logo.svelte";

  let menuOpen = false;

  const portfolioItems = [
    { href: "/admin/dashboard", icon: "fas fa-tv", label: "Dashboard", exact: true, gated: false },
    { href: "/admin/pies", icon: "fas fa-chart-pie", label: "Pies", exact: false, gated: true },
    { href: "/admin/portfolio", icon: "fas fa-wallet", label: "Portfolio", exact: true, gated: true },
    { href: "/admin/orders", icon: "fas fa-exchange-alt", label: "Orders", exact: true, gated: true },
    { href: "/admin/banking", icon: "fas fa-university", label: "Banking", exact: true, gated: true },
    { href: "/admin/documents", icon: "fas fa-file-alt", label: "Documents", exact: true, gated: true },
    { href: "/admin/activities", icon: "fas fa-history", label: "Activities", exact: true, gated: true },
  ];

  function navProps(exact) {
    return ({ isCurrent, isPartiallyCurrent }) => ({
      class: `nav-item ${(exact ? isCurrent : isPartiallyCurrent || isCurrent) ? "nav-item-active" : ""}`,
    });
  }
</script>

<!-- Mobile top bar -->
<div class="md:hidden flex items-center justify-between bg-surface border-b border-line px-4 py-3 sticky top-0 z-40">
  <a use:link href="/admin/dashboard">
    <Logo size={24} />
  </a>
  <button
    type="button"
    class="btn btn-ghost btn-sm"
    aria-label="Open menu"
    on:click={() => (menuOpen = true)}
  >
    <i class="fas fa-bars text-lg"></i>
  </button>
</div>

{#if menuOpen}
  <!-- Mobile overlay -->
  <button
    type="button"
    class="md:hidden fixed inset-0 bg-ink/40 z-40"
    aria-label="Close menu"
    on:click={() => (menuOpen = false)}
  ></button>
{/if}

<!-- Sidebar -->
<nav
  class="fixed top-0 bottom-0 left-0 w-64 bg-surface border-r border-line z-50 flex-col
    overflow-y-auto px-4 py-6
    {menuOpen ? 'flex' : 'hidden'} md:flex"
>
  <div class="flex items-center justify-between px-3 mb-2">
    <a use:link href="/admin/dashboard">
      <Logo />
    </a>
    <button
      type="button"
      class="md:hidden text-ink-tertiary hover:text-ink"
      aria-label="Close menu"
      on:click={() => (menuOpen = false)}
    >
      <i class="fas fa-times text-lg"></i>
    </button>
  </div>

  {#if !$hasAlpacaAccount}
    <div class="banner banner-warning mx-1 mt-4">
      <p class="font-semibold">Finish setting up</p>
      <p class="mt-0.5 text-xs">Complete your account to start investing.</p>
      <a
        use:link
        href="/admin/onboarding"
        class="mt-2 inline-block text-xs font-semibold text-amber-900 underline underline-offset-2 hover:no-underline"
      >
        Complete setup
      </a>
    </div>
  {/if}

  <p class="nav-heading">Portfolio</p>
  <ul class="space-y-0.5" on:click={() => (menuOpen = false)}>
    {#each portfolioItems as item}
      <li>
        {#if !item.gated || $hasAlpacaAccount}
          <Link to={item.href} getProps={navProps(item.exact)}>
            <i class={item.icon}></i>
            {item.label}
          </Link>
        {:else}
          <span class="nav-item opacity-50 cursor-not-allowed hover:bg-transparent hover:text-ink-secondary">
            <i class={item.icon}></i>
            {item.label}
            <i class="fas fa-lock !text-xs ml-auto !w-auto"></i>
          </span>
        {/if}
      </li>
    {/each}
  </ul>

  <p class="nav-heading">Account</p>
  <ul class="space-y-0.5" on:click={() => (menuOpen = false)}>
    <li>
      <Link to="/admin/settings" getProps={navProps(true)}>
        <i class="fas fa-user-circle"></i>
        Settings
      </Link>
    </li>
    <li>
      <button type="button" class="nav-item w-full hover:text-danger" on:click={() => auth.logout()}>
        <i class="fas fa-sign-out-alt"></i>
        Sign out
      </button>
    </li>
  </ul>
</nav>
